import React from 'react';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { HoldingDTO } from '../../api/useAssetBucketingResultsQuery';
import { HtmlTable } from '../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { formatCurrency } from '../../../../../../CommonUtils/formatNumber';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';

interface Props {
  holdings: HoldingDTO[];
  onClose(): void;
}

export const HoldingsModal = ({ holdings, onClose }: Props) => {
  return (
    <Modal
      isOpen
      size="small"
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: 'holdings-modal--header' }}
    >
      <ModalHeader as="h2" id="holdings-modal--header">
        {holdings.length} Holding(s)
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <HtmlTable variant="embedded" fixedHead minHeight={400} maxHeight="80vh">
        <table>
          <thead>
            <tr>
              <th>
                <Text variant="smallCaps" textAlign="left">
                  Security
                </Text>
              </th>

              <th>
                <Text variant="smallCaps" textAlign="right">
                  Market Value
                </Text>
              </th>
            </tr>
          </thead>

          <tbody>
            {holdings.map(holding => (
              <tr key={holding.id}>
                <td>
                  <Box display="flex" flexDirection="column" css="gap: 2px">
                    <Text textAlign="left" fontWeight={500}>
                      {holding.ticker}
                    </Text>
                    <Text textAlign="left" fontSize="small" color="neutral.600">
                      {holding.name}
                    </Text>
                  </Box>
                </td>

                <td>
                  <Text variant="tabular" textAlign="right" fontWeight={500}>
                    {formatCurrency(holding.value, { mantissa: 2 })}
                  </Text>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </HtmlTable>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
